var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 290,
    viewBox: "0 0 2 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447754 0.447754 0 1 0C1.55225 0 2 0.447754 2 1V19C2 19.5522 1.55225 20 1 20C0.447754 20 0 19.5522 0 19V1Z",
    fill: "#EAEDE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 30C0.447754 30 0 30.4478 0 31V49C0 49.5522 0.447754 50 1 50C1.55225 50 2 49.5522 2 49V31C2 30.4478 1.55225 30 1 30Z",
    fill: "#EAEDE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 61C0 60.4478 0.447754 60 1 60C1.55225 60 2 60.4478 2 61V79C2 79.5522 1.55225 80 1 80C0.447754 80 0 79.5522 0 79V61Z",
    fill: "#EAEDE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 90C0.447754 90 0 90.4478 0 91V109C0 109.552 0.447754 110 1 110C1.55225 110 2 109.552 2 109V91C2 90.4478 1.55225 90 1 90Z",
    fill: "#EAEDE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 121C0 120.448 0.447754 120 1 120C1.55225 120 2 120.448 2 121V139C2 139.552 1.55225 140 1 140C0.447754 140 0 139.552 0 139V121Z",
    fill: "#EAEDE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 150C0.447754 150 0 150.448 0 151V169C0 169.552 0.447754 170 1 170C1.55225 170 2 169.552 2 169V151C2 150.448 1.55225 150 1 150Z",
    fill: "#EAEDE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 181C0 180.448 0.447754 180 1 180C1.55225 180 2 180.448 2 181V199C2 199.552 1.55225 200 1 200C0.447754 200 0 199.552 0 199V181Z",
    fill: "#EAEDE6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 210C0.447754 210 0 210.448 0 211V229C0 229.552 0.447754 230 1 230C1.55225 230 2 229.552 2 229V211C2 210.448 1.55225 210 1 210Z",
    fill: "#EAEDE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 241C0 240.448 0.447754 240 1 240C1.55225 240 2 240.448 2 241V259C2 259.552 1.55225 260 1 260C0.447754 260 0 259.552 0 259V241Z",
    fill: "#EAEDE6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 270C0.447754 270 0 270.448 0 271V289C0 289.552 0.447754 290 1 290C1.55225 290 2 289.552 2 289V271C2 270.448 1.55225 270 1 270Z",
    fill: "#EAEDE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.e75c43293c3e6fab66fcd245b84065b4.svg";
export { ForwardRef as ReactComponent };